import { Container, Row, Col, Image } from "react-bootstrap";

export default function CompletedProjects() {
  return (
    <section className="py-5 bg-white">
      <Container>
        <h2 className="text-center text-primary fw-semibold fs-2">Completed Projects</h2>
        <Row className="mt-3 justify-content-center text-center">
          <Col xs={12} md={6}>
            <Image src="/coming-soon.jpg" alt="Coming Soon" className="w-50 rounded-3 shadow-sm" />
            <p className="text-secondary mt-3">
              We are currently updating this section. Stay tuned for details about our successfully completed projects!
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
